import 'expo/build/Expo.fx';
import { activateKeepAwakeAsync } from 'expo-keep-awake';
import registerRootComponent from 'expo/build/launch/registerRootComponent';
import './src/polyfills/intl';
import { createRoot } from 'react-dom/client';
import { createElement } from 'react';
import { Platform } from 'react-native';
import App from './src/App';

// @see https://github.com/software-mansion/react-native-reanimated/issues/3355
if (process.browser) {
  // eslint-disable-next-line no-underscore-dangle
  window._frameTimestamp = null;
}

if (__DEV__) {
  activateKeepAwakeAsync();
  global.XMLHttpRequest = global.originalXMLHttpRequest || global.XMLHttpRequest;
}

// @see https://github.com/expo/expo/issues/18485
if ('web' === Platform.OS) {
  const rootTag = createRoot(document.getElementById('root') ?? document.getElementById('main'));
  rootTag.render(createElement(App));
} else {
  registerRootComponent(App);
}
